export default "https://cdn-static.gokick.com/assets/34a72110398b299a93da730cfac0263ae4687154/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";